var dataStore = require('./selectableData.jsx');
var defaultFetchOptions = require('./accountDataService.jsx').defaultFetchOptions;
var fetchWithAuth = require('./fetchWithAuth.jsx').fetchWithAuth;

var getApiData = function (apiMethod, cacheLookupKey, apiPayloadKey, queryString) {
    return new Promise(function (resolve, reject) {
        if (dataStore[cacheLookupKey] && dataStore[cacheLookupKey].length) {
            resolve(dataStore[cacheLookupKey]);
        } else if (!apiMethod) {
            // ASAWEB-864: without a method name the path collapses to
            // "/api/account/undefined". Skip the request and reject so the
            // dropdown stops loading instead of hanging.
            reject();
        } else {
            queryString = queryString ? queryString : '';
            var fullUrl = '/api/account/' + apiMethod + queryString;

            fetchWithAuth(fullUrl, defaultFetchOptions())
                .then(res => res.json())
                .then((result) => {
                    if (result) {
                        dataStore[cacheLookupKey] = result.response[apiPayloadKey];
                        resolve(result.response[apiPayloadKey]);
                    }
                },
                (error) => {
                    reject();
                });
        }
    }.bind(this));
}

var primaryAddressCountryCode = '';
var selectableData = {
    setPrimaryAddressCountryCode: (countryCode) => primaryAddressCountryCode = countryCode,
    getPrimaryAddressCountryCode: () => primaryAddressCountryCode,
    activeSubboards: () => getApiData('getactivesubboards', 'activeSubboards', 'AppSubCodes'),
    //activeProgramDegrees: () => getApiData('getactiveprogramdegrees', 'activeProgramDegrees', 'AppCodes'),
    clinicalInterests: () => getApiData('getactiveclinicaltopics', 'clinicalInterests', 'Areaofinterests'), // ok
    institutions: () => getApiData('getinstitutions', 'institutions', 'Institution'), // ok
    educationProgramType: () => getApiData('geteducationprogramtypes', 'educationProgramType', 'AppCodes'), // ok
    allEmailPreferences: () => getApiData('getactiveemailpreferences', 'allEmailPreferences', 'AppCodes'), // ok
    fellowshipType: () => getApiData('getactivefellowshiptypes', 'fellowshipType', 'AppCodes'), // ok
    fellowshipSubType: () => getApiData('getactivefellowshipsubtypes', 'fellowshipSubType', 'AppSubCodes'), // ok
    ethnicity: () => getApiData('getactiveethnicitytypes', 'ethnicity', 'Ethnicity'),
    race: () => getApiData('getactiveracetypes', 'race', 'Races'),
    prefix: () => getApiData('getactiveprefixes', 'prefix', 'AppCodes'),
    suffix: () => getApiData('getactivesuffixes', 'suffix', 'AppCodes'),
    credentials: () => getApiData('getactivecredentials', 'credentials', 'AppCodes'),

    militaryBranch: () => getApiData('getallactivemilitarybranches', 'militaryBranch', 'AppSubCodes'),
    militaryPrefix: () => getApiData('getallactivemilitaryranks', 'militaryPrefix', 'AppCodes'),
    governmentSector: () => getApiData('GetAllGovernmentSectors', 'governmentSector', 'AppSubCodes'),

    countries: () => getApiData('getCountries', 'countries', 'Country'),
    statesByCountry: (fetchOptions) => getApiData('getStatesByCountry', 'statesByCountry', 'State', fetchOptions.queryString()),
    countriesAndStates: () => getApiData('getCountriesAndStates', 'countriesAndStates', 'CountryAndState'),
    gender: () => getApiData('getactivegendercodes', 'gender', 'Gender'),

    districts: () => getApiData('GetAllMembershipJoinDistrictInformation', 'districts', 'Districts'),
    primaryPracticeLocations: () => getApiData('GetPrimaryPracticeLocations', 'primaryPracticeLocations', 'PrimaryPracticeLocations')
};

module.exports = selectableData;